import { useState } from "react";
import { balanceTabRent } from "src/api/tronWalletResourceBalance";
import { Box, Button } from "src/components/MuiGenerals";
import { Params } from "src/features/common/types/GridRenderCellParams";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useAlerting, usePermission, useTranslation } from "src/hooks";
import { useZusDialogStore } from "src/zustand/store";

import { RentResourceBatchWalletStatus } from "@wallet-manager/node-types/dist/src/postgres/const";

import { GetListRes } from "../types/GetListRes";
import { postTronRentResourceRecordRefresh } from "src/api/tronRentResourceRecords";
import { FeatureCode } from "@wallet-manager/node-types";

const useOperationButton = () => {
  const { translatePrefix } = usePageConfigProviderContext();

  const [refreshedRow, setRefreshedRow] = useState<string[]>([]);
  const [reRentedRow, setReRentedRow] = useState<string[]>([]);

  const { t } = useTranslation(translatePrefix);
  const zusDialog = useZusDialogStore();
  const { alerting } = useAlerting();
  const { hasPermission } = usePermission();

  const renderOperationButtons = (params: Params<GetListRes>) => {
    const { rawData } = params.row || {};

    const isRowStatusCompleted =
      rawData?.status === RentResourceBatchWalletStatus.Completed;
    const isRowStatusSkipped =
      rawData?.status === RentResourceBatchWalletStatus.Skipped;

    const isWalletHaveEnoughEnergy =
      Number(rawData?.actual_energy) >= Number(rawData?.required_energy);

    const isWalletHaveEnoughBandwidth =
      Number(rawData?.actual_bandwidth) >= Number(rawData?.required_bandwidth);

    const isRefreshButtonDisabled =
      refreshedRow.includes(rawData?.id) ||
      isRowStatusCompleted ||
      isRowStatusSkipped ||
      (isWalletHaveEnoughEnergy && isWalletHaveEnoughBandwidth);

    const isReRentButtonDisabled =
      reRentedRow.includes(rawData?.id) ||
      isRowStatusCompleted ||
      isRowStatusSkipped ||
      (isWalletHaveEnoughEnergy && isWalletHaveEnoughBandwidth);

    const onRefresh = async (data: any) => {
      // TODO: [tron-record] change later, hard code for QA
      const chainType = 3;
      const chainId = 1;
      const walletAddress = rawData?.wallet_address;

      zusDialog.openExtra("loadingDialog");
      const res = await postTronRentResourceRecordRefresh({
        chainType: chainType ? Number(chainType) : null,
        chainId: chainId ? Number(chainId) : null,
        walletAddress: walletAddress,
      });
      zusDialog.closeExtra();

      if (!res) return;

      setRefreshedRow((prev) => [...prev, rawData?.id]);

      alerting("success", t("submitSuccess"));
    };

    const onReRent = async () => {
      // TODO: [tron-record] change later, hard code for QA
      const chainType = 3;
      const chainId = 1;

      const payload = {
        chainType: chainType ? Number(chainType) : null,
        chainId: chainId ? Number(chainId) : null,

        walletAddress: rawData?.wallet_address,
        requiredEnergy: isWalletHaveEnoughEnergy
          ? String(0)
          : String(rawData.required_energy),
        requiredBandwidth: isWalletHaveEnoughBandwidth
          ? String(0)
          : String(rawData.required_bandwidth),
        rentPeriodSecond: String(3600),
      };

      zusDialog.openExtra("loadingDialog");
      const res = await balanceTabRent(payload);
      zusDialog.closeExtra();

      if (!res) return;

      setReRentedRow((prev) => [...prev, rawData?.id]);
      alerting("success", t("submitSuccess"));
    };

    const haveRefreshPermission = hasPermission(
      FeatureCode.FeaturesAssetManagement.TronRentResourceRecords.Refresh,
    );
    const haveReRentPermission = hasPermission(
      FeatureCode.FeaturesAssetManagement.TronRentResourceRecords.ReRent,
    );

    //Todo refresh api
    //Todo dialog (keep or change to api when requirement or api ready)
    return (
      <Box gap={1} display={"flex"}>
        {haveRefreshPermission && (
          <Button
            color="secondary"
            variant="contained"
            onClick={onRefresh}
            disabled={isRefreshButtonDisabled}
          >
            {t("refresh")}
          </Button>
        )}
        {/* <DialogProvider>
          <RerentDialog rawData={rawData} />
          <DialogProvider.Toggle>{t("reRent")}</DialogProvider.Toggle>
        </DialogProvider> */}

        {haveReRentPermission && (
          <Button
            color="secondary"
            variant="contained"
            onClick={onReRent}
            disabled={isReRentButtonDisabled}
          >
            {t("reRent")}
          </Button>
        )}
      </Box>
    );
  };
  return { renderOperationButtons };
};
export default useOperationButton;
